/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (max-width:599px){ .task-type-picker{width:100%}}@media screen and (min-width:600px){ .task-type-picker{width:400px}} .task-type-picker .mat-dialog-container{padding:0} .task-type-picker .mat-dialog-container .mat-toolbar{flex:1 0 auto;min-height:initial} .task-type-picker .dialog-content-wrapper{max-height:85vh;display:flex;flex-direction:column} .task-type-picker .task-type-button{margin:10px 0;min-width:100%}.task-editor-dialog[_ngcontent-%COMP%]{width:400px}"];
export { styles as styles };
